<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Desatualizados
      <span
        v-b-tooltip.hover
        title="Cidadãos com cadastros (CI ou CDT) desatualizados há mais de 2 anos"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Atualizados
      <span
        v-b-tooltip.hover
        title="Cidadãos com cadastros (CI e CDT) atualizados há menos de 2 anos"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <!-- <div v-for="(item, index) in this.$props.items" class="subtitle-item">
            <span v-bind:style="{ 'background-color': item.color }"></span> {{item.text}}
            <span v-if="item.tooltip" v-b-tooltip.hover v-bind:title="item.textTooltip" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span>
        </div> -->
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.reds = true
          this.greens = false
        } else {
          this.reds = false
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style scoped></style>
